<!-- begin:: Error -->
<div
  class="error error-6 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
  style="background-image: url(../../../../../../assets/media/error/bg6.jpg); height: 100%"
>
  <!-- begin:: Content -->
  <div class="d-flex flex-column flex-row-fluid text-center">
    <h1 class="error-title font-weight-boldest text-white mb-12" style="margin-top: 12rem">
      Oops!
    </h1>
    <p class="display-4 font-weight-bold text-white">
      Looks like you lost your internet connection.<br /><br />
      <button mat-raised-button color="primary" (click)="checkConnection()">Try Again</button>
    </p>
  </div>
  <!-- end:: Content -->
</div>
<!-- end:: Error -->
